export default __webpack_public_path__ + "static/team-ilko-37478d2f2ed13a7af21b2b264fcb2ad2.png";